import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

export const SubNavBarContainerStyles = styled.div`
  // Note: The shared header has a box shadow (.nav-container) that overlaps the category bar and is visible when
  //    the category bar background is white. This is set in app.styled.js

  background-color: #fff;
  height: 60px;
  top: 0;
  z-index: 8;
  border-bottom: solid 1px ${Colors.accent.grey4.standard};
`;
